
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/node/section_index_page",
      function () {
        return require("private-next-pages/node/section_index_page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/node/section_index_page"])
      });
    }
  